import { type ComponentProps, memo, useMemo } from 'react';
import { Block } from 'streamdown';

import { AiResponseBlockContext } from '../AiResponseBlockContext.js';
import { hasUnterminatedFence } from '../utils/fence-utils.js';

/**
 * Wraps a Streamdown block to provide its streaming state to the components rendered
 * within it. It is memoized because it replaces Streamdown's own memoized block, which
 * keeps unchanged blocks from re-rendering on every streamed token.
 * @internal
 */
export const AiResponseBlock = memo((props: ComponentProps<typeof Block>) => {
  const { content } = props;

  const blockState = useMemo(
    () => ({ isComplete: !hasUnterminatedFence(content) }),
    [content],
  );

  return (
    <AiResponseBlockContext.Provider value={blockState}>
      <Block {...props} />
    </AiResponseBlockContext.Provider>
  );
});
